import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        {/* Top Navigation Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* Navigation */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-500 mb-4 uppercase">
              {t("footer.navigation")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/"
                className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t("footer.home")}
              </Link>
              <Link
                to="/guia-cssbuy-sheet"
                className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t("footer.guide")}
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t("footer.safety_page")}
              </a>
            </div>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-500 mb-4 uppercase">
              {t("footer.categories")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Categories Continued */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-500 mb-4 uppercase">
              {t("footer.guides")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-foreground-500 mb-4 uppercase">
              {t("footer.legal")}
            </h4>
            <div className="w-8 h-px bg-background-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t("footer.privacy")}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t("footer.terms")}
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors cursor-pointer"
              >
                {t("footer.disclaimer")}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Brand Area */}
        <div className="border-t border-background-200/70 pt-10 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6">
          <div>
            <div className="flex items-baseline gap-1.5 mb-3">
              <span className="text-2xl font-bold tracking-wider text-foreground-900 font-heading">
                CSSBUY
              </span>
              <span className="text-base font-light tracking-[0.2em] text-foreground-600 font-heading">
                SPREADSHEETS
              </span>
            </div>
            <div className="w-10 h-px bg-background-300 mb-3"></div>
            <p className="text-xs text-foreground-500">{t("footer.brand_tagline")}</p>
          </div>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
              aria-label="Twitter"
            >
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
              aria-label="Discord"
            >
              <i className="ri-discord-line text-lg"></i>
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-background-200/70">
          <p className="text-xs text-foreground-400">{t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
}